<template>
  <v-card v-bind="$attrs">
    <v-list-item @click="$emit('click')" link>
      <v-list-item-content>
        <v-list-item-title class="mb-2">
          {{ scheduling.scheduling_type.name }}
          <SchedulingStatusChip
            class="ml-2"
            :status="scheduling.status"
            small
            label
          />
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ __("próxima tentativa de contacto") }}:
          <span
            v-if="scheduling.next_attempt_at"
            v-text="scheduling.next_attempt_at_diff"
            :title="scheduling.next_attempt_at"
          ></span>
          <span v-else>---</span>
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          {{ __("data marcada") }}:
          {{
            scheduling.date ? `${scheduling.date} ${scheduling.time}` : "---"
          }}
          <span class="mx-2"></span>
          {{ __("expira em") }}:
          <span
            v-if="scheduling.expires_at_diff"
            v-text="scheduling.expires_at_diff"
            :title="scheduling.expires_at"
          ></span>
          <span v-else v-text="'---'"></span>
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          <span v-for="attempt in scheduling.attempts" :key="attempt.id">
            {{ attempt.order }}ª {{ __(" tentativa: ") }}
            {{ attempt.date_formatted }}
            <span class="mx-2"></span>
          </span>
          <span v-if="scheduling.attempts.length < 1">
            Nenhuma tentativa de contacto registada
          </span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-actions>
      <v-btn
        v-for="action in actions_to_show"
        :key="action.code"
        text
        small
        :color="action.color"
        @click="$emit(`click:${action.code}`)"
      >
        <v-icon left>{{ action.icon }}</v-icon> {{ action.title }}
      </v-btn>

      <v-menu v-if="actions_to_hide.length > 0" offset-x right>
        <template #activator="{ attrs, on }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-subheader>{{ __("ações") }}</v-subheader>
          <v-list-item
            v-for="action in actions_to_hide"
            :key="action.code"
            @click="$emit(`click:${action.code}`)"
            :class="`${action.color}--text`"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon left :color="action.color">{{ action.icon }}</v-icon>
                {{ action.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-actions>
    <LogsDialog ref="logs" />
  </v-card>
</template>

<script>
import SchedulingStatusChip from "./SchedulingStatusChip.vue";
import i18n from "@/mixins/i18n";
import { useSchedullingActions } from "@/constants/SchedullingActions";

export default {
  mixins: [i18n],
  components: {
    SchedulingStatusChip,
  },

  props: {
    scheduling: Object,
  },

  data() {
    return {
      i18n_prefix: "schedulings",
      schedullingActions: useSchedullingActions(),
    };
  },

  computed: {
    available_actions() {
      const { SCHEDULE_ACTION, FAILURE_ACTION, CANCEL_ACTION, SHOW_LOGS } =
        this.schedullingActions;

      switch (this.scheduling.status) {
        case "pending":
          return [SCHEDULE_ACTION, FAILURE_ACTION, CANCEL_ACTION, SHOW_LOGS];
        case "failure":
          return [SHOW_LOGS];
        case "concluded":
          return [CANCEL_ACTION, SHOW_LOGS];
        case "canceled":
          return [SHOW_LOGS];
        case "refused":
          return [SHOW_LOGS];
        case "letter":
          return [SCHEDULE_ACTION, CANCEL_ACTION, SHOW_LOGS];
        default:
          return [SHOW_LOGS];
      }
    },

    actions_to_show() {
      return this.available_actions.filter((action) => !action.hidden);
    },

    actions_to_hide() {
      return this.available_actions.filter((action) => action.hidden);
    },
  },
};
</script>
